function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
import { bind, Component, dataParam, register } from 'ovee.js';
gsap.registerPlugin(ScrollToPlugin);
var EventNav = (_dec = register('event-nav'), _dec2 = dataParam('target'), _dec3 = bind('click'), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(EventNav, _Component);

  var _super = _createSuper(EventNav);

  function EventNav() {
    var _this;

    _classCallCheck(this, EventNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "header", document.querySelector('.header'));

    _defineProperty(_assertThisInitialized(_this), "nav", document.querySelector('.event-nav'));

    _defineProperty(_assertThisInitialized(_this), "firstSectionHeading", document.querySelector('.hero-nav-height--heading'));

    _defineProperty(_assertThisInitialized(_this), "tickets", document.querySelector('.ticket-container'));

    _defineProperty(_assertThisInitialized(_this), "observer", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "targetSelector", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "sections", []);

    return _this;
  }

  _createClass(EventNav, [{
    key: "scrollTop",
    value: function scrollTop(e) {
      e.preventDefault();
      e.stopPropagation();
      var activeElement = this.nav.querySelector('.is-active');

      if (activeElement) {
        activeElement.classList.remove('is-active');
      }

      e.currentTarget.classList.add('is-active');
      var speed = 1;
      var ease = 'power2.inOut';
      var ticketsHeight;
      var headerHeight = this.header.getBoundingClientRect().height;
      var navHeight = this.nav.getBoundingClientRect().height;

      if (this.tickets !== null) {
        ticketsHeight = this.tickets.getBoundingClientRect().height;
      } else {
        ticketsHeight = 0;
      }

      var totalHeight = headerHeight + navHeight + ticketsHeight + 20;
      var _window = window,
          innerHeight = _window.innerHeight,
          scrollY = _window.scrollY;
      var distance = Math.abs(scrollY);
      var duration = (Math.log(distance) / Math.log(innerHeight) + Math.sqrt(distance) / Math.sqrt(innerHeight)) * speed * 0.5; // eslint-disable-line

      if (duration === -Infinity) duration = 0.7;
      gsap.to(window, {
        duration: duration,
        scrollTo: {
          y: this.targetSelector,
          offsetY: totalHeight
        },
        ease: ease
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.updateNavHeightVar();
      this.initSections();
      this.initObserver();
      window.addEventListener('resize', this.delayedResizeHandler(this.updateNavHeightVar, 300, 300));
    }
  }, {
    key: "delayedResizeHandler",
    value: function delayedResizeHandler(func, throttleDelay, debounceDelay) {
      var _this2 = this;

      var lastCall = 0;
      var debounceTimer = null;
      var rafId = null; // Track the last known dimensions

      var lastHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var lastWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var now = new Date().getTime();
        var currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var currentWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth; // Calculate changes

        var heightChange = Math.abs(currentHeight - lastHeight);
        var widthChange = Math.abs(currentWidth - lastWidth); // Update the last known dimensions

        lastHeight = currentHeight;
        lastWidth = currentWidth; // Trigger only on significant height changes or any width change

        if (heightChange < 100 && widthChange === 0) {
          return false;
        }

        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(function () {
          if (!rafId) {
            rafId = requestAnimationFrame(function () {
              func.apply(_this2, args);
              rafId = null;
            });
          }
        }, debounceDelay);

        if (now - lastCall >= throttleDelay) {
          lastCall = now;

          if (!rafId) {
            rafId = requestAnimationFrame(function () {
              func.apply(_this2, args);
              rafId = null;
            });
          }
        }

        return false;
      };
    }
  }, {
    key: "updateNavHeightVar",
    value: function updateNavHeightVar() {
      var root = document.documentElement;

      if (this.nav && this.nav.offsetParent !== null) {
        var navHeight = this.nav.getBoundingClientRect().height;
        root.style.setProperty('--hero-nav-height', "".concat(navHeight, "px"));
      } else if (this.firstSectionHeading && this.firstSectionHeading !== null) {
        var firstSectionHeadingHeight = this.firstSectionHeading.getBoundingClientRect().height;
        var ctaButton = this.firstSectionHeading.querySelector('.flexible-event__mobile-tickets');

        if (ctaButton && ctaButton !== null) {
          firstSectionHeadingHeight += ctaButton.getBoundingClientRect().height;
        }

        root.style.setProperty('--hero-nav-height', "".concat(firstSectionHeadingHeight, "px"));
      } else {
        root.style.removeProperty('--hero-nav-height');
      }
    }
  }, {
    key: "initObserver",
    value: function initObserver() {
      var _this3 = this;

      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
      this.sections.forEach(function (section) {
        _this3.observer.observe(section);
      });
    }
  }, {
    key: "initSections",
    value: function initSections() {
      var links = Array.from(this.nav.querySelectorAll('[data-target]'));
      this.sections = links.map(function (link) {
        var targetId = link.getAttribute('data-target');
        return document.querySelector(targetId);
      }).filter(function (section) {
        return section !== null;
      });
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this4 = this;

      entries.forEach(function (entry) {
        var targetId = entry.target.getAttribute('id');

        var button = _this4.nav.querySelector("[data-target=\"#".concat(targetId, "\"]"));

        if (entry.isIntersecting) {
          _this4.nav.querySelectorAll('.is-active').forEach(function (activeButton) {
            activeButton.classList.remove('is-active');
          });

          if (button) {
            button.classList.add('is-active');
          }
        }
      });
    }
  }]);

  return EventNav;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "targetSelector", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "scrollTop", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "scrollTop"), _class2.prototype)), _class2)) || _class);
export { EventNav as default };